import { LandPlot } from 'lucide-react';
import { Button } from './Button';
import { useTask } from 'engine/store';
import { useNavigate } from '@tanstack/react-router';

const _modelOptions = ['pagoda', 'carnavalwagen', 'karaf', 'kruidenkraam', 'moskee', 'vrijheidsbeeld', 'ukraine', 'sitar'] as const;
export type ModelTypes = (typeof _modelOptions)[number];

export function ARFormComponent({ taskId, roundId }: { model?: ModelTypes; readOnly?: boolean; taskId: string; roundId: string }) {
	const navigate = useNavigate();
	const { task } = useTask(roundId, taskId);
	const openFullscreen = () => {
		if (task?.type === 'augmented-reality') {
			console.log('navigating to augmented reality', task.id);
			navigate({ to: '/ar-scene/$roundId/$taskId', replace: true, params: { roundId, taskId: task.id } });
		}
	};
	return (
		<>
			<Button onClick={openFullscreen} className={`relative m-auto aspect-square h-32 w-2/3 cursor-pointer overflow-hidden`}>
				<LandPlot /> AR
			</Button>
		</>
	);
}
